import AddHandleLetterOld from './AddHandleLetterOld.jsx';

export {
  AddHandleLetterOld
};



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/add-handle-letters-old/index.js